import { render, staticRenderFns } from "./TextRadio.vue?vue&type=template&id=59338380&scoped=true"
import script from "./TextRadio.vue?vue&type=script&lang=js"
export * from "./TextRadio.vue?vue&type=script&lang=js"
import style0 from "./TextRadio.vue?vue&type=style&index=0&id=59338380&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59338380",
  null
  
)

export default component.exports